import { toast } from 'react-toastify';

import {
    getMailboxAppHref,
    getMailboxCaseDetailLocation,
    getMailboxCaseDetailPath,
    getMailboxIntentItem,
    storeMailboxBackLocation,
} from '../helpers';

const TOAST_DURATION_MS = 8000;

const shouldUseBrowserNavigation = (event) => (
    event.defaultPrevented
    || event.button !== 0
    || event.metaKey
    || event.altKey
    || event.ctrlKey
    || event.shiftKey
);

const MailboxCaseCreatedToast = ({
    title,
    body,
    href,
    to,
    linkLabel,
    fromLocation,
    history,
}) => {
    const handleClick = (event) => {
        storeMailboxBackLocation(fromLocation);

        if (!history || !to || shouldUseBrowserNavigation(event)) {
            return;
        }

        event.preventDefault();
        history.push(to);
    };

    return (
        <div className="mailbox-created-toast__content">
            <div className="mailbox-created-toast__title">
                {title}
            </div>
            <div className="mailbox-created-toast__text">
                {body}
            </div>
            {href && linkLabel ? (
                <a
                    className="mailbox-created-toast__link"
                    href={href}
                    onClick={handleClick}
                >
                    {linkLabel}
                    {' →'}
                </a>
            ) : null}
        </div>
    );
};

const createdToastOptions = {
    position: 'bottom-left',
    closeButton: true,
    autoClose: TOAST_DURATION_MS,
    closeOnClick: false,
    pauseOnHover: true,
    pauseOnFocusLoss: false,
    draggable: false,
    className: 'mailbox-created-toast',
};

export const showMailboxCaseCreatedToast = (t, linkedCase, fromLocation, history) => {
    const intentItem = getMailboxIntentItem(linkedCase?.intent);

    if (!intentItem) {
        toast.success(t('Created case from mailbox email'), createdToastOptions);
        return;
    }

    const path = getMailboxCaseDetailPath(linkedCase);
    const href = getMailboxAppHref(path);
    const to = getMailboxCaseDetailLocation(linkedCase, fromLocation) || path;

    toast.success(
        <MailboxCaseCreatedToast
            title={t(intentItem.createdTitleKey)}
            body={t(intentItem.createdBodyKey)}
            href={href}
            to={to}
            linkLabel={t(intentItem.viewKey)}
            fromLocation={fromLocation}
            history={history}
        />,
        createdToastOptions
    );
};

export default MailboxCaseCreatedToast;
